export default __webpack_public_path__ + "static/media/lulububu-blue.57bb4255.png";